import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
    WithReportFormatContentPayload
} from "../../../../../../reporting/report/impl/service/payload/withReportFormatContent.payload";
import {
    ReportFormatContentPayload
} from "../../../../../../communication/common/api/service/reportFormatContent.payload";
import {CustomizeHttpUrlGenerator} from "../../../../../../../store/core/url/customizeHttpUrlGenerator";
import {AbstractActionService} from "../../../../../../core/service/v2/service/action/abstractAction.service";

@Injectable()
export class SaleInvoiceFormatContentActionService extends AbstractActionService<SaleInvoiceFormatContentPayload, any> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient) {
        super('SaleInvoice', 'format-content', customizeHttpUrlGenerator, httpClient);
    }

    buildOptions(payload: SaleInvoiceFormatContentPayload): any {
        return {
            responseType: 'text',
        };
    }
}

export class SaleInvoiceFormatContentPayload implements WithReportFormatContentPayload {
    report: ReportFormatContentPayload;
    id: number;
}
